import React, { useEffect } from 'react';
import { State } from 'state';
import { useDispatch, useSelector } from 'react-redux';
import Modal from 'utils/components/modal';
import {
  clearAllModals as clearAllModalsAction,
  closeModal as closeModalAction
} from '../state/actions';
import { ModalType } from '../state/types';
import { ConfirmationModal as ConfirmationModalGeneral } from '../../../sharable/components/modals/ConfirmationModal';

import styles from './ModalManager.module.scss';

import * as modals from '../modal';
import classNames from 'classnames';

const {
  BackToCommentsModal,
  ConfirmationModal,
  AddToBlockListModal,
  SessionExpiredModal,
  AuditLogModal,
  AssignGroupModal
} = modals;

const MODALS = {
  [ModalType.CONFIRM]: ConfirmationModal,
  [ModalType.VIEW_CONVERSATION]: BackToCommentsModal,
  [ModalType.ADD_TO_BLOCKLIST]: AddToBlockListModal,
  [ModalType.MODERATION_SESSION_EXPIRED]: SessionExpiredModal,
  [ModalType.AUDIT_LOG]: AuditLogModal,
  [ModalType.ASSIGN_GROUP]: AssignGroupModal,
  [ModalType.CONFIRM_GENERAL]: ConfirmationModalGeneral
};

const ModalManager: React.FC = ({}) => {
  const currentModals = useSelector((state: State) => state.modals?.currentModals || []);
  const dispatch = useDispatch();

  const closeModal = () => dispatch(closeModalAction());

  const clearAllModals = () => dispatch(clearAllModalsAction());

  useEffect(() => {
    return clearAllModals;
  }, []);

  return (
    <>
      {currentModals.map(({ modalType, modalProps = {} }, index) => {
        const ModalComponent = MODALS[modalType];

        if (ModalComponent) {
          const { onConfirm, onClose = () => {}, className } = modalProps;

          const close = props => {
            onClose(props);
            closeModal();
          };

          return (
            <Modal
              className={classNames(className, styles.modal)}
              key={`${modalType}-${index}`}
              visible={true}
              closable={true}
              onHide={close}
              onConfirm={onConfirm}
              keepVisibleOnOverlayClick={false}
              style={styles}
            >
              <ModalComponent {...modalProps} onClose={close} />
            </Modal>
          );
        }
      })}
    </>
  );
};

export default ModalManager;
